export default {
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    label: String,
    checked: Boolean,
    small: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classIsChecked() {
      return this.checked ? 'checkbox__tick--checked' : '';
    },
    checkboxModifiers() {
      return {
        'checkbox--small': this.small,
      };
    },
  },
  methods: {
    onChange(e) {
      this.$emit('change', e.target.checked);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/forms/checkbox/checkbox.js